export default "__VITE_ASSET__B5SSnQA5__"